import { Button, Flex, Table } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import type { ICompanyData } from '../../../../../../shared/types/company';
import CompanyRegModal from '../../Modal/CompanyRegModal';

interface IPropsCompanyInfo {
  data?: ICompanyData;
}

export default function CompanyInfo(props: IPropsCompanyInfo) {
  const { data } = props;
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <div>
      <Flex justify="flex-end" mb="sm">
        <Button onClick={open}>거래처 정보 수정</Button>
      </Flex>
      <Table variant="vertical" withTableBorder>
        <Table.Tbody>
          <Table.Tr>
            <Table.Th>거래처명</Table.Th>
            <Table.Td>{data?.name || ''}</Table.Td>
            <Table.Th>거래처 전화번호</Table.Th>
            <Table.Td>{data?.tel || ''}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>대표자명</Table.Th>
            <Table.Td>{data?.repName || ''}</Table.Td>
            <Table.Th>거래처 이메일</Table.Th>
            <Table.Td>{data?.email || ''}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>사업자번호</Table.Th>
            <Table.Td>{data?.businessNum || ''}</Table.Td>
            <Table.Th>회사 코드</Table.Th>
            <Table.Td>{data?.id || ''}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>거래처 주소</Table.Th>
            <Table.Td colSpan={3}>{data?.address || ''}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>메모</Table.Th>
            <Table.Td colSpan={3}>{data?.memo || ''}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
      {opened && <CompanyRegModal isEdit opened={opened} closeModal={close} data={data} />}
    </div>
  );
}
